import { render } from "./RuiHeader.vue?vue&type=template&id=92fd40c8&scoped=true"
import script from "./RuiHeader.vue?vue&type=script&lang=ts"
export * from "./RuiHeader.vue?vue&type=script&lang=ts"

import "./RuiHeader.vue?vue&type=style&index=0&id=92fd40c8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-92fd40c8"

export default script